module.exports = __webpack_public_path__ + "img/QuartoCrescente.9a11bf57.svg";